/* eslint-disable no-undef */
import React from 'react';
import Banner from './Banner';
import { Styles } from './style';
import BannerCaixa from '@assets/images/banner-caixa.png';
import BannerCadastro from '@assets/images/banner-cadastro.png';
import BannerEncomende from '@assets/images/banner-encomende.png';
import { useMediaQuery, useTheme } from '@mui/material';

const bannerGroups = {
  mainBanners: [
    {
      image: BannerCaixa,
      link: 'https://www8.caixa.gov.br/siopiinternet-web/simulaOperacaoInternet.do?method=inicializarCasoUso',
      target: '_blank',
      width: 374,
      height: 122
    },
    {
      image: BannerCadastro,
      link: '/cadastrar-imovel',
      target: '_self',
      width: 374,
      height: 122
    },
    {
      image: BannerEncomende,
      link: '/encomendar-imovel',
      target: '_self',
      width: 374,
      height: 122
    }
  ]
};

const AppBanner: React.FC = () => {
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Styles.BannerContainer>
      {/* {!isMobile &&
        bannerGroups.topBanners.map((banner, index) => (
          <Styles.TopBanner key={`top-${index}`}>
            <Banner
              src={banner.image}
              width={banner.width}
              height={banner.height}
              border={false}
              link={banner.link}
            />
          </Styles.TopBanner>
        ))} */}
      <Styles.BannerRow>
        {bannerGroups.mainBanners.map((banner, index) => (
          <Styles.BannerItem key={index}>
            <Banner
              src={banner.image}
              width={banner.width}
              height={banner.height}
              border={false}
              link={banner.link}
            />
          </Styles.BannerItem>
        ))}
      </Styles.BannerRow>
    </Styles.BannerContainer>
  );
};

export default AppBanner;
